import api from "./axios.config";
import {
  ChannelData,
  OtpCodeSendPayload,
  OtpCodeVerifyPayload,
  OtpCodeVerifySuccessPayload,
  UserModel,
} from "./axiosTypes";

export class WebChatApi {
  static async otpCodeSend(request: OtpCodeSendPayload) {
    try {
      const response = await api.post(
        "/customer/Authentication/otp/start",
        request
      );
      return response.data;
    } catch (error) {
      console.error("otpCodeSend - Error: ", error);
      throw error;
    }
  }

  static async otpCodeVerify(request: OtpCodeVerifyPayload) {
    try {
      const response = await api.post<OtpCodeVerifySuccessPayload>(
        "/customer/Authentication/otp/complete",
        request
      );
      return response.data;
    } catch (error) {
      console.error("otpCodeVerify - Error: ", error);
      throw error;
    }
  }

  static async getMe() {
    try {
      const response = await api.get<UserModel>("/customer/Me");
      return response.data;
    } catch (error) {
      console.error("getMe - Error: ", error);
      throw error;
    }
  }

  static async getNewChannelId() {
    try {
      const response = await api.post<ChannelData>(
        "/customer/jarvis/new-channel"
      );
      return response.data;
    } catch (error) {
      console.error("getNewChannelId - Error: ", error);
      throw error;
    }
  }
}
